import { render, staticRenderFns } from "./SettingsPanel.vue?vue&type=template&id=06149a83&scoped=true"
import script from "./SettingsPanel.vue?vue&type=script&lang=js"
export * from "./SettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./SettingsPanel.vue?vue&type=style&index=0&id=06149a83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06149a83",
  null
  
)

export default component.exports